export default "__VITE_ASSET__CL6MYLPo__"